import { toast, ToastContent, ToastOptions } from 'react-toastify';
export const defaultToastOptions: ToastOptions = {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};
const useToastify = () => {
    const showToastSuccess = (constent: ToastContent, toastOptions?: ToastOptions) => {
        toast.success(constent, { ...defaultToastOptions, ...toastOptions });
    };

    const showToastError = (constent: ToastContent, toastOptions?: ToastOptions) => {
        toast.error(constent, { ...defaultToastOptions, ...toastOptions });
    };

    const showToastWarning = (constent: ToastContent, toastOptions?: ToastOptions) => {
        toast.warn(constent, { ...defaultToastOptions, ...toastOptions });
    };

    const showToastInfo = (constent: ToastContent, toastOptions?: ToastOptions) => {
        toast.info(constent, { ...defaultToastOptions, ...toastOptions });
    };

    return { showToastSuccess, showToastError, showToastWarning, showToastInfo };
};

export default useToastify;
